import React from 'react'
import { ConfigConsumer } from 'antd/lib/config-provider'

import { Empty } from '../empty'

export const renderEmpty = (componentName?: string): React.ReactNode => (
  <ConfigConsumer>
    {() => {
      switch (componentName) {
        case 'Table':
        case 'List':
          return <Empty type="no-result" />

        case 'Select':
        case 'TreeSelect':
        case 'Cascader':
        case 'Transfer':
        case 'Mentions':
          return <Empty size="mini" />
        default:
          return <Empty />
      }
    }}
  </ConfigConsumer>
)
